import { render, staticRenderFns } from "./DeliveryStateBadge.vue?vue&type=template&id=ac82e8a0&lang=pug&"
import script from "./DeliveryStateBadge.vue?vue&type=script&lang=js&"
export * from "./DeliveryStateBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports